import React from 'react';
import { IButtonBlockPreviewProps } from './IButtonBlockPreviewProps';
import { ButtonAction, scrollElementIntoView } from 'containers/PageBuilder/SinglePageContainer/domain';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import styled from 'styled-components';
import BlockButton from '../BlockComponents/BlockButton';
import miscUtils from 'utils/miscUtils';

const ButtonBlockContentContainer: any = styled(BlockContentContainer)`
    flex-direction: row;
    justify-content: ${(props: any) => 
        props.design.button_alignment === 'left' ?
        'flex-start' :
        props.design.button_alignment === 'right' ?
        'flex-end' :
        props.design.button_alignment
    };
`;

export const BlockButtonsContainer: any = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    &.mobile {
        flex-direction: column;
        align-items: flex-start;
    }

    @media(max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`

const ButtonBlockButton: any = styled(BlockButton)`
    margin-top: 0px;
    width: fit-content;
`;

export const BlockSideButton: any = styled(BlockButton)`
    margin-left: 15px;

    &.no-margin-top {
        margin-top: 0px;
    }

    &.mobile {
        margin-left: 0;
        margin-top: 15px;
    }

    @media(max-width: 768px) {
        margin-left: 0;
        margin-top: 15px;
    }
`

const ButtonBlockPreview: React.FC<IButtonBlockPreviewProps> = (props) => {

  const ctaOnClick = (blockData: any) => {
    if(props.buildingPreview) {
        return;
    }

    if(
        blockData &&
        (
            blockData.button_action === ButtonAction.URL ||
            blockData.button_action === ButtonAction.URLTab
        ) &&
        blockData.button_url
    ) {
        window.open(
            miscUtils.ensureHttps(blockData.button_url), 
            blockData.button_action === ButtonAction.URLTab ?
            '_blank' :
            '_self'
        );
        return;
    }

    if(
        blockData &&
        blockData.button_action === ButtonAction.Scroll &&
        blockData.button_url &&
        props.containerBaseIdName
    ) {
        scrollElementIntoView(`${props.containerBaseIdName}${blockData.button_url}`);
        return;
    }

    if(
        blockData &&
        blockData.button_action === ButtonAction.Popup &&
        blockData.button_url
    ) {
        let nextPageFormsOpenState = JSON.parse(JSON.stringify(props.pageFormsOpenState));

        nextPageFormsOpenState[blockData.button_url] = true;

        props.setPageFormsOpenState(nextPageFormsOpenState);
        return;
    }

    if(
        blockData &&
        blockData.button_action === ButtonAction.Page &&
        blockData.button_url
    ) {
        window.open(
            `${blockData.button_url}`, 
            '_self'
        );
        return;
    }
  }

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <ButtonBlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
            <BlockButtonsContainer
            className={`${props.view ? props.view : ''}`}
            >
                <ButtonBlockButton
                design={props.blockData.design}
                pageStyles={props.pageStyles}
                onClick={() => ctaOnClick(props.blockData)}
                >
                    {props.blockData.button_text}
                </ButtonBlockButton>

                {props.blockData.side_by_side_buttons ? (
                    props.blockData.side_by_side_buttons.map((side_by_side_button: any, index: number) => (
                        <BlockSideButton
                        key={`${index}`}
                        className={`${props.view ? props.view : ''} no-margin-top`}
                        design={side_by_side_button.design}
                        pageStyles={props.pageStyles}
                        onClick={() => ctaOnClick(side_by_side_button)}
                        >
                            {side_by_side_button.button_text}
                        </BlockSideButton>
                    ))
                ) : <></>}
            </BlockButtonsContainer>
        </ButtonBlockContentContainer>
    </BlockContainer>
  )
}

export default ButtonBlockPreview;